export default function ShieldIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.9987 18.8333C9.9987 18.8333 16.6654 15.5 16.6654 10.5V4.66667L9.9987 2.16667L3.33203 4.66667V10.5C3.33203 15.5 9.9987 18.8333 9.9987 18.8333Z"
        stroke="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
